{
	"actionRequiredMessage": "Your account access is currently limited. Please update your billing details or upgrade your plan to restore full access.",
	"actionRequiredTitle": "Action Required",
	"exportAnyway": "Export anyway",
	"exporting": "Exporting",
	"goToPixieset": "Go to Pixieset Photo Editor",
	"legacyUpgradeMessage": "This export exceeds your available credits. As we prepare to transition to Pixieset Photo Editor, credits are no longer available to purchase. You can continue editing and exporting with Pixieset Photo Editor.",
	"legacyUpgradeTitle": "Ready for more? Join Pixieset Photo Editor!",
	"lowStorageMessage": "{{action}} a large album can fail if your device runs low on free space. Free up some room before continuing for best results.",
	"lowStorageTitle": "You may be low on storage",
	"manageBilling": "Manage Billing",
	"needOnlineToExport": "You need to be online and logged in to export",
	"publishAnyway": "Publish anyway",
	"publishing": "Publishing",
	"seePricing": "See Pricing",
	"upgradeMessage": "You've reached your trial limit. Upgrade to a full plan for unlimited AI editing and culling, personal AI Styles and RAW editing. One simple price, no per-image fees.",
	"upgradeTitle": "Ready for more?"
}
